module.exports = __webpack_public_path__ + "img/logo-mars-scientific.04e6c399.png";